import { GetServerSidePropsContext } from 'next';
import '@hey-car/intl-seo-hub.page-builder/dist/index.css';
import {
  BlogHubPage,
  IBlogHubPage,
  getServerSideProps as getServerSidePropsBlogHubPage,
} from 'app/containers/BlogHubPage/BlogHubPage';
import { BASE_ROUTES } from 'app/hooks/useUrl/useUrl';
import { GUIDES_PAGE_TYPES } from 'app/apiCalls/kentico';

interface IGuidesHubPageProps extends IBlogHubPage {}

const GuidesHubPage = (props: IGuidesHubPageProps) => {
  return <BlogHubPage {...props} linkPrefix={`${BASE_ROUTES.guides}/`} />;
};

const getServerSideProps = async (context: GetServerSidePropsContext) => {
  return getServerSidePropsBlogHubPage({
    ...context,
    params: { itemCodename: 'guides_hub_page', types: GUIDES_PAGE_TYPES },
  });
};

export { GuidesHubPage, getServerSideProps };
